// #region CONSTANTS

export const NOOP = () => {};

export const KEY_ARROW_LEFT = "ArrowLeft";
export const KEY_ARROW_RIGHT = "ArrowRight";
export const KEY_ARROW_UP = "ArrowUp";
export const KEY_ARROW_DOWN = "ArrowDown";
export const KEY_HOME = "Home";
export const KEY_END = "End";
export const KEY_PAGE_UP = "PageUp";
export const KEY_PAGE_DOWN = "PageDown";

export const END_NORMAL = "normal";
export const END_LOOP = "loop";

export const TRANSITION_SLIDE = "slide";
export const TRANSITION_FADE = "fade";
export const TRANSITION_OFF = "off";

export const DRAG_OFF = "off";

export const WHEEL_MOVE_ONCE = "move-once";
export const WHEEL_FREE = "free";
export const WHEEL_OFF = "off";

export const ORIENTATION_HORIZONTAL = "horizontal";
export const ORIENTATION_VERTICAL = "vertical";
export const AXIS_X = "x";
export const AXIS_Y = "y";

export const DIRECTION_LTR = "ltr";
export const DIRECTION_RTL = "rtl";

export const MOVE_DIRECTION_NEXT = "next";
export const MOVE_DIRECTION_PREVIOUS = "previous";

// NOTE: These are from Splide. Just here for reference.

// eslint-disable-next-line no-unused-vars -- kept as reference from upstream Splide
const I18N = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  /** [slide number] of [slide size] */
  slideLabel: "%s of %s",
};

// eslint-disable-next-line no-unused-vars -- kept as reference from upstream Splide
const DEFAULTS = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: true,
  arrows: true,
  pagination: true,
  paginationKeyboard: true,
  interval: 5000,
  pauseOnHover: true,
  pauseOnFocus: true,
  resetProgress: true,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: true,
  direction: "ltr",
  trimSpace: true,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: true,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause",
  },
};

// eslint-disable-next-line no-unused-vars -- kept as reference from upstream Splide
const SCROLL_LISTENER_OPTIONS = { passive: false, capture: true };

// eslint-disable-next-line no-unused-vars -- kept as reference from upstream Splide
const MEDIA_MOTION_OK = "(prefers-reduced-motion: no-preference)";
